import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import {
    EntryOptions,
    PropertyDefinition,
    PropertyMappingType,
} from "app/library/layout-builder";
import { ImagePopupProps } from "./types";
import { MetaTypeEnum } from "app/shared";
import { ImageChildrenDefinitions } from 'components/cms/definitions';

export class ImagePopupDefinitions extends CmsReactComponent<ImagePopupProps> {
    static defaultProps = {};

    static schemaName = "image-popup";

    static propertyDefinitions: PropertyDefinition[] = [
        {
            name: "title",
            mapping: {
                type: PropertyMappingType.String,
            },
            description: "Başlık",
        },
        {
            name: "thumb",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: ImageChildrenDefinitions,
            },
            description: "Küçük görsel",
        }, {
            name: "image",
            mapping: {
                type: PropertyMappingType.ParentObject,
                children: ImageChildrenDefinitions,
            },
            description: "Büyük görsel",
        }];

    static options: EntryOptions = {
        meta: {
            use: true,
            allowedTypes: [
                MetaTypeEnum.Text,
                MetaTypeEnum.TextArea,
                MetaTypeEnum.SingleImage,
                MetaTypeEnum.Editor,
            ],
        },
    };
}
